import { put, takeEvery, call } from "redux-saga/effects";
// import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import * as actionTypes from "./constants";
import endpoints from "../endpoints";
// import api from "../api";
import fmApi from "../APIWrapper";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({ type: `${value.initAction}`, value: value.initPayload });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

// function* commonPostFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({ type: `${value.initAction}`, value: value.initPayload });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       if (err.status === 400) {
//         yield put({ type: `${value.failAction}`, error: err });
//         yield toast.error(`${endpoints.status400}`, {
//           autoClose: 3000,
//         });
//       } else if (err.status === 500) {
//         yield put({ type: `${value.failAction}`, error: err });
//         yield toast.error(`${endpoints.status500}`, {
//           autoClose: 3000,
//         });
//       } else {
//       }
//     }
//   }
// }

// WATER TANKER SAGA ---------------------------------------------

function* fetchpurchase(params) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let month =
    params?.value?.startDateMonthvalue < 10
      ? "0" + params?.value?.startDateMonthvalue
      : params?.value?.startDateMonthvalue;
  const data = {
    society: `${fmsUser.society_id}`,
    source: "commercial",
    month: month,
    year: params?.value?.startDateYearvalue || null,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/waterpurchase`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_PURCHASE_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_PURCHASE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.fetchWaterTankerApi, data);
    yield put({
      type: actionTypes.FETCH_PURCHASE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_PURCHASE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addWaterTanker(value) {
  const values = value?.value;
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const capitalizeWord = (data) => {
    if (data) {
      return typeof data === "string"
        ? data.charAt(0).toUpperCase() + data.slice(1)
        : "";
    }
    return data;
  };
  let data = {
    societyId: `${fmsUser.society_id}`,
    date: values.value.billDate,
    quantity: values.value.quantity,
    amount: values.value.amount,
    vendorName: capitalizeWord(values.value.supplier),
    ...(value?.value?.inputTypeValue === "0" && {
      numOfTankers: values.value.noOfTanker,
    }),
    ratePerQty: values.value.rate,
    tankerCapacity: values.value.tankerCapcity,
    type: "commercial",
    startTime: values?.value?.startTime,
    endTime: values?.value?.endTime,
    ...(value?.value?.inputTypeValue !== "0" && {
      startReading: Number(values?.value?.startReading),
      endReading: Number(values?.value?.endReading),
    }),
  };
  let initPayload = {
    startDateYearvalue: new Date().getFullYear(),
    startDateMonthvalue: new Date().getMonth() + 1,
  };

  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/addWater`,
    //   method: "POST",
    //   sucessAction: actionTypes.ADD_WATERTANKER_SUCCESS_ACTION,
    //   initAction: actionTypes.FETCH_PURCHASE_INIT_ACTION,
    //   initPayload: {
    //     startDateYearvalue: new Date().getFullYear(),
    //     startDateMonthvalue: new Date().getMonth() + 1,
    //   },
    //   toastMsg: "Water tanker purchase info added successfully",
    //   failAction: actionTypes.ADD_WATERTANKER_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PostWaterTankerAddWaterApi, data);

    yield put({
      type: actionTypes.ADD_WATERTANKER_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_PURCHASE_INIT_ACTION,
      value: initPayload,
    });

    yield toast.success("Water tanker purchase info added successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({
          type: actionTypes.ADD_WATERTANKER_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield put({
          type: actionTypes.ADD_WATERTANKER_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* upadateWaterTanker(value) {
  const values = value?.value;
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const capitalizeWord = (data) => {
    if (data) {
      return typeof data === "string"
        ? data.charAt(0).toUpperCase() + data.slice(1)
        : "";
    }
    return data;
  };
  let data = {
    societyId: `${fmsUser.society_id}`,
    pId: `${values.value.pid}`,
    date: values.value.billDate,
    quantity: values.value.quantity,
    amount: values.value.amount,
    vendorName: capitalizeWord(values.value.supplier),
    numOfTankers: values.value.noOfTanker,
    ratePerQty: values.value.rate,
    tankerCapacity: values.value.tankerCapcity,
    startTime: values?.value?.startTime,
    endTime: values?.value?.endTime,
    ...(value?.value?.inputTypeValue !== "0" && {
      startReading: Number(values?.value?.startReading),
      endReading: Number(values?.value?.endReading),
    }),
    type: "commercial",
    vendorId: null,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/editWater`,
    //   method: "POST",
    //   sucessAction: actionTypes.UPDATE_WATERTANKER_SUCCESS_ACTION,
    //   toastMsg: "Water tanker purchase info updated successfully",
    //   failAction: actionTypes.UPDATE_WATERTANKER_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PatchWaterTankerApi, data);

    yield put({
      type: actionTypes.UPDATE_WATERTANKER_SUCCESS_ACTION,
      payload: resJSON,
    });

    yield toast.success("Water tanker purchase info updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({
          type: actionTypes.UPDATE_WATERTANKER_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield put({
          type: actionTypes.UPDATE_WATERTANKER_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* DeleteWaterTanker(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const token = localStorage.getItem("fmsToken");
  const data = {
    source: "commercial",
    recordId: `${value.value.pid}`,
    societyId: `${fmsUser.society_id}`,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/deleteWater`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.DeleteWaterTankerApi, data);

    yield put({
      type: actionTypes.DELETE_WATERTANKER_SUCCESS_ACTION,
      payload: { resJSON: resJSON, pid: value.value.pid },
    });
    toast.success("Water tanker purchase info deleted successfully");
    return resJSON;
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_WATERTANKER_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

// MUNCIPAL WATER SAGA ---------------------------

function* fetchmuncipalwater(muncipaldata) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let month =
    muncipaldata?.value?.startDateMonthvalue < 10
      ? "0" + muncipaldata?.value?.startDateMonthvalue
      : muncipaldata?.value?.startDateMonthvalue;

  const data = {
    society: `${fmsUser.society_id}`,
    source: "municipal",
    month: month,
    year: muncipaldata?.value?.startDateYearvalue || null,
  };

  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/waterpurchase`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_MUNCIPAL_WATER_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_MUNCIPAL_WATER_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonFunction, params);

    // return Res;
    const resJSON = yield call(fmApi.fetchMunicipalWaterApi, data);
    yield put({
      type: actionTypes.FETCH_MUNCIPAL_WATER_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_MUNCIPAL_WATER_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addMuncipalWaterData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const token = localStorage.getItem("fmsToken");
  const data = {
    societyId: `${fmsUser.society_id}`,
    billNo: value.value.billNo,
    startReading: value.value.prevReading,
    endReading: value.value.currentReading,
    quantity: value.value.netQty,
    amount: value.value.billAmount,
    receiptNo: value.value.receiptNo,
    date: value.value.billDate,
    paymentDate: value.value.paymentDate,
    type: "municipal",
    vendorId: null,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/addWater`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.PostMunicipalWaterAddApi, data);

    const initPayload = {
      startDateYearvalue: new Date().getFullYear(),
      startDateMonthvalue: new Date().getMonth() + 1,
    };
    yield put({
      type: actionTypes.ADD_MUNCIPAL_WATER_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_MUNCIPAL_WATER_INIT_ACTION,
      value: initPayload,
    });
    yield toast.success("Municipal water purchase info added successfully", {
      autoClose: 3000,
    });
    return resJSON;
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_MUNCIPAL_WATER_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error("Bill number is already exist", {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* updateMuncipalWaterData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const token = localStorage.getItem("fmsToken");
  const data = {
    societyId: `${fmsUser.society_id}`,
    pId: `${value.value.pid}`,
    billNo: value.value.billNo,
    endReading: value.value.currentReading,
    startReading: value.value.prevReading,
    quantity: value.value.netQty,
    amount: value.value.billAmount,
    receiptNo: value.value.receiptNo,
    date: value.value.billDate,
    paymentDate: value.value.paymentDate,
    type: "municipal",
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/editWater`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.PatchMunicipalWaterApi, data);

    yield put({
      type: actionTypes.UPDATE_MUNCIPAL_WATER_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield toast.success("Municipal water purchase info updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_MUNCIPAL_WATER_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error("Bill number is already exist", {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* deleteMuncipalData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const token = localStorage.getItem("fmsToken");
  const data = {
    source: "municipal",
    recordId: `${value.value.pid}`,
    societyId: `${fmsUser.society_id}`,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/deleteWater`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    // const resJSON = yield res.json();
    const resJSON = yield call(fmApi.DeleteMunicipalWaterApi, data);

    yield put({
      type: actionTypes.DELETE_MUNCIPAL_WATER_SUCCESS_ACTION,
      payload: { resJSON: resJSON, pid: value.value.pid },
    });
    toast.success("Municipal water purchase info deleted successfully");

    return resJSON;
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_MUNCIPAL_WATER_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, { autoClose: 3000 });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

// RAIN WATER-------------

function* fetchRainWaterPurchase(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let month =
    value?.value?.startDateMonthvalue < 10
      ? "0" + value?.value?.startDateMonthvalue
      : value?.value?.startDateMonthvalue;
  const data = {
    society: `${fmsUser.society_id}`,
    source: "rain",
    month: month,
    year: value?.value?.startDateYearvalue || null,
  };

  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/waterpurchase`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_RAIN_WATER_PURCHASE_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_RAIN_WATER_PURCHASE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.fetchRainWaterApi, data);
    yield put({
      type: actionTypes.FETCH_RAIN_WATER_PURCHASE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_RAIN_WATER_PURCHASE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addRainWaterData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let data = {
    societyId: `${fmsUser.society_id}`,
    endReading: value.value.endReading,
    startReading: value.value.startReading,
    quantity: value.value.Qty,
    date: value.value.date,
    type: "rain",
  };
  let initPayload = {
    startDateYearvalue: new Date().getFullYear(),
    startDateMonthvalue: new Date().getMonth() + 1,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/addWater`,
    //   method: "POST",
    //   sucessAction: actionTypes.ADD_RAIN_WATER_PURCHASE_SUCCESS_ACTION,
    //   initAction: actionTypes.FETCH_RAIN_WATER_PURCHASE_INIT_ACTION,
    //   initPayload: {
    //     startDateYearvalue: new Date().getFullYear(),
    //     startDateMonthvalue: new Date().getMonth() + 1,
    //   },
    //   toastMsg: " Rain water/RO purchase info added successfully",
    //   failAction: actionTypes.FETCH_RAIN_WATER_PURCHASE_INIT_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);

    // return Res;
    const resJSON = yield call(fmApi.PostRainWaterApi, data);

    yield put({
      type: actionTypes.ADD_RAIN_WATER_PURCHASE_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_RAIN_WATER_PURCHASE_INIT_ACTION,
      value: initPayload,
    });

    yield toast.success("Rain water/RO purchase info added successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({
          type: actionTypes.ADD_RAIN_WATER_PURCHASE_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield put({
          type: actionTypes.ADD_RAIN_WATER_PURCHASE_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* updateRainWaterData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let data = {
    societyId: `${fmsUser.society_id}`,
    pId: `${value.value.pid}`,
    endReading: value.value.endReading,
    startReading: value.value.startReading,
    quantity: value.value.Qty,
    date: value.value.date,
    type: "rain",
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/editWater`,
    //   method: "POST",
    //   sucessAction: actionTypes.UPDATE_RAIN_WATER_PURCHASE_SUCCESS_ACTION,
    //   toastMsg: " Rain water/RO purchase info updated successfully",
    //   failAction: actionTypes.UPDATE_RAIN_WATER_PURCHASE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PatchRainWaterApi, data);

    yield put({
      type: actionTypes.UPDATE_RAIN_WATER_PURCHASE_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield toast.success("Rain water/RO purchase info updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({
          type: actionTypes.UPDATE_RAIN_WATER_PURCHASE_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield put({
          type: actionTypes.UPDATE_RAIN_WATER_PURCHASE_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* deleteRainWaterData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const token = localStorage.getItem("fmsToken");
  const data = {
    source: "rain",
    recordId: `${value.value.pid}`,
    societyId: `${fmsUser.society_id}`,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/deleteWater`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.DeleteRainWaterApi, data);

    yield put({
      type: actionTypes.DELETE_RAIN_WATER_PURCHASE_SUCCESS_ACTION,
      payload: { resJSON: resJSON, pid: value.value.pid },
    });
    toast.success("Rain water/RO purchase info deleted successfully");
    return resJSON;
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_RAIN_WATER_PURCHASE_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

// GROUND WATER-------------

function* fetchGroundWaterData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let month =
    value?.value?.startDateMonthvalue < 10
      ? "0" + value?.value?.startDateMonthvalue
      : value?.value?.startDateMonthvalue;
  const data = {
    society: `${fmsUser.society_id}`,
    source: "ground",
    month: month,
    year: value?.value?.startDateYearvalue || null,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/waterpurchase`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_GROUND_WATER_PURCHASE_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_GROUND_WATER_PURCHASE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.fetchGroundWaterApi, data);
    yield put({
      type: actionTypes.FETCH_GROUND_WATER_PURCHASE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_GROUND_WATER_PURCHASE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addGroundWaterData(value) {
  const values = value?.value;
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let data = {
    societyId: `${fmsUser.society_id}`,
    endReading: values.value.endReading,
    startReading: values.value.startReading,
    quantity: values.value.Qty,
    date: values.value.date,
    type: "ground",
    startTime: values?.value?.startTime,
    endTime: values?.value?.endTime,
    borewellType: values?.value?.borewellType,
  };
  let initPayload = {
    startDateYearvalue: new Date().getFullYear(),
    startDateMonthvalue: new Date().getMonth() + 1,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/addWater`,
    //   method: "POST",
    //   sucessAction: actionTypes.ADD_GROUND_WATER_PURCHASE_SUCCESS_ACTION,
    //   initAction: actionTypes.FETCH_GROUND_WATER_PURCHASE_INIT_ACTION,
    //   initPayload: {
    //     startDateYearvalue: new Date().getFullYear(),
    //     startDateMonthvalue: new Date().getMonth() + 1,
    //   },
    //   toastMsg: "Ground water purchase info added successfully",
    //   failAction: actionTypes.FETCH_GROUND_WATER_PURCHASE_INIT_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PostGroundWaterApi, data);

    yield put({
      type: actionTypes.ADD_GROUND_WATER_PURCHASE_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_GROUND_WATER_PURCHASE_INIT_ACTION,
      value: initPayload,
    });

    yield toast.success("Ground water purchase info added successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({
          type: actionTypes.FETCH_GROUND_WATER_PURCHASE_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield put({
          type: actionTypes.FETCH_GROUND_WATER_PURCHASE_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* updateGroundWaterData(value) {
  const values = value?.value;
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let data = {
    societyId: `${fmsUser.society_id}`,
    pId: `${values.value.pid}`,
    endReading: values.value.endReading,
    startReading: values.value.startReading,
    quantity: values.value.Qty,
    date: values.value.date,
    type: "ground",
    startTime: values?.value?.startTime,
    endTime: values?.value?.endTime,
    borewellType: values?.value?.borewellType,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/editWater`,
    //   method: "POST",
    //   sucessAction: actionTypes.UPDATE_GROUND_WATER_PURCHASE_SUCCESS_ACTION,
    //   toastMsg: "Ground water purchase info updated successfully",
    //   failAction: actionTypes.UPDATE_GROUND_WATER_PURCHASE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PatchGroundWaterApi, data);

    yield put({
      type: actionTypes.UPDATE_GROUND_WATER_PURCHASE_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield toast.success("Ground water purchase info updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({
          type: actionTypes.UPDATE_GROUND_WATER_PURCHASE_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield put({
          type: actionTypes.UPDATE_GROUND_WATER_PURCHASE_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* deleteGroundWaterData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const token = localStorage.getItem("fmsToken");
  const data = {
    source: "ground",
    recordId: `${value.value.pid}`,
    societyId: `${fmsUser.society_id}`,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/deleteWater`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.DeleteGroundWaterApi, data);
    yield put({
      type: actionTypes.DELETE_GROUND_WATER_PURCHASE_SUCCESS_ACTION,
      payload: { resJSON: resJSON, pid: value.value.pid },
    });
    toast.success("Ground water purchase info deleted successfully");
    return resJSON;
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_GROUND_WATER_PURCHASE_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchPurchaseData(params) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));

  const data = {
    society: `${fmsUser.society_name}`,
    from: params?.value?.from,
    to: params?.value?.to,
  };

  try {
    const resJSON = yield call(fmApi.WaterPurchaseApi, data);

    yield put({
      type: actionTypes.FETCH_PURCHASE_DATA_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_PURCHASE_DATA_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

// function* addWaterPurchase(params) {
//   const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));

//   const data = {
//     society: `${fmsUser.society_name}`,
//     WaterSourceEntry: params?.value.data,
//   };
//   const filterData = {
//     society: `${fmsUser.society_name}`,
//     from: params?.value?.filterParams?.from,
//     to: params?.value?.filterParams?.to,
//   };
//   try {
//     const resJSON = yield call(fmApi.AddWaterPurchaseApi, data);
//     if (resJSON.status === "Success") {
//       toast.success("Purchase data updated successfully");
//       yield put({
//         type: actionTypes.ADD_PURCHASE_DATA_SUCCESS_ACTION,
//         payload: resJSON,
//       });
//       yield put({
//         type: actionTypes.FETCH_PURCHASE_DATA_INIT_ACTION,
//         value: filterData,
//       });
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({
//         type: actionTypes.ADD_PURCHASE_DATA_FAIL_ACTION,
//         error: err,
//       });
//     } else {
//     }
//   }
// }

function* addWaterPurchase(params) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));

  const filterData = {
    society: fmsUser.society_name,
    from: params?.value?.filterParams?.from,
    to: params?.value?.filterParams?.to,
  };

  try {
    const payload = params?.value?.data;

    const dataArray = Array.isArray(payload) ? payload : [payload];

    for (const item of dataArray) {
      const requestData = {
        society: fmsUser.society_name,
        WaterSourceEntry: item,
      };

      const resJSON = yield call(fmApi.AddWaterPurchaseApi, requestData);

      if (resJSON.status !== "Success") {
        throw resJSON;
      }
    }

    toast.success("Purchase data updated successfully");

    yield put({
      type: actionTypes.ADD_PURCHASE_DATA_SUCCESS_ACTION,
    });

    yield put({
      type: actionTypes.FETCH_PURCHASE_DATA_INIT_ACTION,
      value: filterData,
    });
  } catch (err) {
    yield put({
      type: actionTypes.ADD_PURCHASE_DATA_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchDateMeterReading(params) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));

  const dayStartUTC = Math.floor(
    Date.parse(`${params?.value?.fromDate}T00:00:00Z`) / 1000
  );
  const dayEndUTC = Math.floor(
    Date.parse(`${params?.value?.toDate}T23:59:59Z`) / 1000
  );

  const data = {
    property: `${fmsUser.society_name}`,
    meterId: params?.value?.meterId,
    start: dayStartUTC,
    end: dayEndUTC,
  };

  try {
    const resJSON = yield call(fmApi.SourceMeterReadingsApi, data);

    yield put({
      type: actionTypes.FETCH_DATE_METER_READING_SUCCESS_ACTION,
      payload: resJSON?.data,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_DATE_METER_READING_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* PurchaseActionWatcher() {
  // WATER TANKER---------------------
  yield takeEvery(actionTypes.FETCH_PURCHASE_INIT_ACTION, fetchpurchase);
  yield takeEvery(actionTypes.ADD_WATERTANKER_INIT_ACTION, addWaterTanker);
  yield takeEvery(
    actionTypes.UPDATE_WATERTANKER_INIT_ACTION,
    upadateWaterTanker
  );
  yield takeEvery(
    actionTypes.DELETE_WATERTANKER_INIT_ACTION,
    DeleteWaterTanker
  );
  // MUNCIPAL WATER ----------------------
  yield takeEvery(
    actionTypes.FETCH_MUNCIPAL_WATER_INIT_ACTION,
    fetchmuncipalwater
  );
  yield takeEvery(
    actionTypes.ADD_MUNCIPAL_WATER_INIT_ACTION,
    addMuncipalWaterData
  );
  yield takeEvery(
    actionTypes.UPDATE_MUNCIPAL_WATER_INIT_ACTION,
    updateMuncipalWaterData
  );
  yield takeEvery(
    actionTypes.DELETE_MUNCIPAL_WATER_INIT_ACTION,
    deleteMuncipalData
  );
  // RAIN WATER------------------------
  yield takeEvery(
    actionTypes.FETCH_RAIN_WATER_PURCHASE_INIT_ACTION,
    fetchRainWaterPurchase
  );
  yield takeEvery(
    actionTypes.ADD_RAIN_WATER_PURCHASE_INIT_ACTION,
    addRainWaterData
  );
  yield takeEvery(
    actionTypes.UPDATE_RAIN_WATER_PURCHASE_INIT_ACTION,
    updateRainWaterData
  );
  yield takeEvery(
    actionTypes.DELETE_RAIN_WATER_PURCHASE_INIT_ACTION,
    deleteRainWaterData
  );
  // GROUND WATER-------------------
  yield takeEvery(
    actionTypes.FETCH_GROUND_WATER_PURCHASE_INIT_ACTION,
    fetchGroundWaterData
  );
  yield takeEvery(
    actionTypes.ADD_GROUND_WATER_PURCHASE_INIT_ACTION,
    addGroundWaterData
  );
  yield takeEvery(
    actionTypes.UPDATE_GROUND_WATER_PURCHASE_INIT_ACTION,
    updateGroundWaterData
  );
  yield takeEvery(
    actionTypes.DELETE_GROUND_WATER_PURCHASE_INIT_ACTION,
    deleteGroundWaterData
  );
  yield takeEvery(
    actionTypes.FETCH_PURCHASE_DATA_INIT_ACTION,
    fetchPurchaseData
  );
  yield takeEvery(actionTypes.ADD_PURCHASE_DATA_INIT_ACTION, addWaterPurchase);
  yield takeEvery(
    actionTypes.FETCH_DATE_METER_READING_INIT_ACTION,
    fetchDateMeterReading
  );
}
